import { render, staticRenderFns } from "./ReportCurrentLocation.vue?vue&type=template&id=6f72b9af&scoped=true"
import script from "./ReportCurrentLocation.vue?vue&type=script&lang=ts"
export * from "./ReportCurrentLocation.vue?vue&type=script&lang=ts"
import style0 from "./ReportCurrentLocation.vue?vue&type=style&index=0&id=6f72b9af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f72b9af",
  null
  
)

export default component.exports